import { useEffect, useState } from "react";
import { Loading } from "@components";
import { message } from "antd";
import { Navigate } from "react-router-dom";
import * as API from "@api";

export default function ProductPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!data) {
      API.Products.create({
        name: `New Product`,
        type: "wine",
        price: 0.0,
        currency: "eur",
        active: false,
      })
        .then((res) => {
          if (!res || res?.error) {
            throw new Error("Error while creating product");
          }

          setData(res?.data);
        })
        .catch((err) => {
          return message.error(
            err?.message || "Error while creating product",
            2
          );
        });
    }
  }, [data]);

  if (data?.id) {
    return <Navigate to={`/products/edit/${data?.id}`} />;
  }

  return <Loading />;
}
